import * as types from "./../action-types";
import axios from "axios";
import { isArray, get } from "lodash";

const normalizeRestockDt = (products) => {
  if (isArray(products)) {
    products.forEach((product) => {
      let date = new Date(product.restock_dt);
      product.restock_dt = isNaN(date) ? null : product.restock_dt;
    });
  }
};
const fetchAccountRequests = ({ commit, rootGetters }, params) => {
  return new Promise((resolve, reject) => {
    const id = rootGetters["db/account/customerId"];
    let url = `v2/customer_requests/load_by_customer?customer_id=${id}`;
    if (params) {
      url = `${url}&${params.join("&")}`;
    }
    axios
      .get(url)
      .then((response) => {
        commit(types.FETCH_ACCOUNT_REQUESTS.SUCCESS, response.data);
        resolve(response.data);
      })
      .catch((error) => {
        commit(types.FETCH_ACCOUNT_REQUESTS.ERROR, error);
        reject(error);
      });
  });
};

async function fetchProductSkus({}, { deviceId, country, state }) {
  try {
    const response = await axios.get(
      `/v2/customer_requests/load_replacements_options?device_id=${deviceId}&country=${country}&state=${state}`
    );
    normalizeRestockDt(get(response, "data.skus", []));
    return response;
  } catch (error) {
    throw error.response;
  }
}

const createRequest = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    axios
      .post("v2/customer_requests", { customer_request: data })
      .then((response) => {
        // Update device data
        commit("db/device/updateDeviceState", response.data, { root: true });
        resolve(response);
      })
      .catch((error) => reject(error));
  });
};

const searchCustomerInfo = ({ commit }, customerId) => {
  return new Promise((resolve, reject) => {
    axios
      .get("v2/customer_requests/load_customer_info", {
        params: {
          customer_id: customerId,
        },
      })
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
};

const searchShipmentDetails = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    axios
      .get("v2/customer_requests/load_shipment_details", { params: data })
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
};

const moveRequest = ({ commit }, { requestId, comment }) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`v2/customer_requests/${requestId}/cancel`, { comment })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => reject(error));
  });
};

const fetchRequestsBy = ({ commit, rootGetters }, { id }) => {
  return new Promise((resolve, reject) => {
    const isV3 = rootGetters["auth/isNewLeftNav"] === true;

    let url;
    if (isV3) {
      url = `v3/plc_requests/${id}`;
    } else {
      url = `v2/customer_requests/${id}`;
    }

    axios
      .get(url)
      .then((response) => {
        if (response.data && response.data.customer_id) {
          resolve(response.data);
        } else {
          reject();
        }
      })
      .catch((error) => reject(error));
  });
};

const fetchReturn = ({ commit }, uuid) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`/customer_requests/${uuid}.json`)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => reject(error));
  });
};

const fetchReturnLabels = ({ commit }, uuid) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`v2/return_labels/${uuid}`)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => reject(error));
  });
};

const generateReturnLabel = ({ commit }, { uuid, customEmail }) => {
  let path = `v2/return_labels/${uuid}/generate`;
  let body = {};
  if (customEmail) body.email = customEmail;

  return new Promise((resolve, reject) => {
    axios
      .post(path, body)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => reject(error));
  });
};

const recoverReturnLabel = ({ commit }, { uuid, label_id }) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`v2/return_labels/${uuid}/recover`, { label_id: label_id })
      .then((response) => {
        commit(types.UPDATE_REQUEST_DATA, response.data);
        resolve(response.data);
      })
      .catch((error) => reject(error));
  });
};

const deleteReturnLabel = ({ commit }, { uuid, label_id }) => {
  return new Promise((resolve, reject) => {
    axios
      .delete(`v2/return_labels/${uuid}/cancel?label_id=${label_id}`)
      .then((response) => {
        commit(types.UPDATE_REQUEST_DATA, response.data);
        resolve(response.data);
      })
      .catch((error) => reject(error));
  });
};
export default {
  fetchProductSkus,
  fetchAccountRequests,
  createRequest,
  searchCustomerInfo,
  searchShipmentDetails,
  moveRequest,
  fetchRequestsBy,
  fetchReturnLabels,
  fetchReturn,
  generateReturnLabel,
  recoverReturnLabel,
  deleteReturnLabel,
};
